// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"ca282299d05c6fd8","888":"171a8faaa4044564"}[chunkId] + ".css";
};